import styled, { css } from 'styled-components';

// @ts-nocheck
var tripadvisorColor = '#589442';
var TripadvisorRating = styled.div.withConfig({
  displayName: "TripadvisorRatingstyle__TripadvisorRating",
  componentId: "sc-lsqg7i-0"
})(["align-items:center;display:inline-flex;flex-direction:column;", " ", ""], function (_ref) {
  var $hasOnClick = _ref.$hasOnClick;
  return $hasOnClick && css(["cursor:pointer;"]);
}, function (_ref2) {
  var $inlineLabel = _ref2.$inlineLabel;
  return $inlineLabel && css(["flex-direction:row;align-items:center;gap:var(--space-100);"]);
});
var RatingContainer = styled.div.withConfig({
  displayName: "TripadvisorRatingstyle__RatingContainer",
  componentId: "sc-lsqg7i-1"
})(["align-items:center;display:inline-flex;text-align:center;gap:var(--space-100);"]);
var Grade = styled.span.withConfig({
  displayName: "TripadvisorRatingstyle__Grade",
  componentId: "sc-lsqg7i-2"
})(["color:var(--color-text);font:var(--font-body-m);"]);
var RatingImageWrapper = styled.span.withConfig({
  displayName: "TripadvisorRatingstyle__RatingImageWrapper",
  componentId: "sc-lsqg7i-3"
})(["display:flex;align-items:center;svg{height:1.4rem;width:1.4rem;margin-left:1px;fill:", ";}"], tripadvisorColor);
var Label = styled.div.withConfig({
  displayName: "TripadvisorRatingstyle__Label",
  componentId: "sc-lsqg7i-4"
})(["color:var(--color-text-subtle);"]);

export { Grade, Label, RatingContainer, RatingImageWrapper, TripadvisorRating };
//# sourceMappingURL=TripadvisorRating.style.js.map
